import React, { useMemo } from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { ReactTable } from 'components/shared/ReactTable';
import FormTableControl from './FormTableControl';
import FormTableDropdownControl from './FormTableDropdownControl';
import FormTableHeading from './FormTableHeading';
import styles from './FormTable.module.css';

const columns = [
  {
    id: 'label',
    accessor: (item) => item.label,
    Header: 'Parameter',
    className: styles.cell
  },
  {
    id: 'value',
    accessor: (item) => item.unit ? `${item.value} ${item.unit}` : item.value,
    Header: 'Current Value',
    className: styles.cell,
    sortable: false
  },
  {
    id: 'input',
    Header: 'New Value',
    Cell: ({ original }) => {
      return original.hidden ? null : original.inputType === 'dropdown' ? (
        <FormTableDropdownControl name={original.name} disabled={original.disabled} options={original.options} unit={original.unit}/>
      ) : (
        <FormTableControl name={original.name} disabled={original.disabled} option={original.option} unit={original.unit}/>
      );
    },
    className: styles.cell,
    sortable: false
  },
  {
    id: 'updatedTime',
    accessor: (parameter) => (parameter.lastUpdated ? new Date(parameter.lastUpdated) : null),
    Header: 'Last Updated',
    Cell: ({ value }) => (value ? moment(value).format('MMM DD, YYYY h:mm a') : null),
    className: styles.cell
  }
];

function FormTable({ values, meta, parameters, className, customColumns, pageSize }) {
  const data = useMemo(
    () => parameters.map((field) => ({ ...field, value: values[field.name], ...meta?.[field.name] })),
    [parameters, values, meta]
  );

  return (
    <ReactTable
      className={classNames(styles.root, className)}
      data={data}
      columns={customColumns ?? columns}
      showPagination={false}
      pageSize={pageSize ?? Math.max(data.length, 4)}
      ThComponent={FormTableHeading}
      getTheadThProps={(props, _rowInfo, column) => ({
        sortable: column?.sortable ?? props.sortable
      })}
    />
  );
}

export default FormTable;
